import { computed, ref } from 'vue';
import { readPosition } from '../lib/persistedState';

export function useDevWindow() {
const devWindowOpen = ref(false);
const devMessages = ref<string[]>(['Dev-Fenster bereit. Es kann Statusnachrichten von Chronis und der Erweiterung empfangen.']);
const devWindowPosition = ref((() => {
  const saved = readPosition(localStorage, 'chronis.dev-window.position.v1');
  return { x: Math.max(16, saved?.x ?? 310), y: Math.max(16, saved?.y ?? 88) };
})());
const devWindowStyle = computed(() => ({ left: `${devWindowPosition.value.x}px`, top: `${devWindowPosition.value.y}px` }));
let devWindowDrag: { offsetX: number; offsetY: number } | null = null;
function addDevMessage(message: unknown) {
  const text = String(message ?? '').trim();
  if (!text) return;
  devMessages.value = [`${new Date().toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}  ${text}`, ...devMessages.value].slice(0, 60);
}
function toggleDevWindow() { devWindowOpen.value = !devWindowOpen.value; }
function openDevWindow() { devWindowOpen.value = true; }
function startDevWindowDrag(event: PointerEvent) {
  if ((event.target as HTMLElement).closest('button')) return;
  devWindowDrag = { offsetX: event.clientX - devWindowPosition.value.x, offsetY: event.clientY - devWindowPosition.value.y };
  window.addEventListener('pointermove', moveDevWindow);
  window.addEventListener('pointerup', stopDevWindowDrag);
}
function moveDevWindow(event: PointerEvent) {
  if (!devWindowDrag) return;
  devWindowPosition.value = { x: Math.max(8, event.clientX - devWindowDrag.offsetX), y: Math.max(8, event.clientY - devWindowDrag.offsetY) };
}
function stopDevWindowDrag() {
  if (!devWindowDrag) return;
  devWindowDrag = null;
  window.removeEventListener('pointermove', moveDevWindow);
  window.removeEventListener('pointerup', stopDevWindowDrag);
  try { localStorage.setItem('chronis.dev-window.position.v1', JSON.stringify(devWindowPosition.value)); } catch { /* Speicher ist optional. */ }
}
function receiveDevMessage(event: MessageEvent) {
  if (event.source !== window || event.origin !== location.origin || event.data?.type !== 'chronis-dev-message') return;
  addDevMessage(event.data.message);
}
  return { devWindowOpen, devMessages, devWindowPosition, devWindowStyle, addDevMessage, toggleDevWindow, openDevWindow, startDevWindowDrag, moveDevWindow, stopDevWindowDrag, receiveDevMessage };
}
